const groupUsersByRole = userOptions => {
  const groups = new Map()
  userOptions.forEach(option => {
    const label = option.roleLabel || ''
    if (!groups.has(label))
      groups.set(label, [])
    groups.get(label).push(option)
  })
  return [...groups].map(([label, options]) => ({ label, options }))
}

export default groupUsersByRole
